export function headerSearch() {
  const searchForm = $(".header-search-form");
  const searchField = searchForm.find("input[type=\"search\"]");
  const langSwitcher = $(".lang-switcher");
  searchForm.on("click", function () {
    if(window.innerWidth < 1200) {
      $(this).addClass("expanded");
      langSwitcher.addClass("hidden");
    }
  });
  this.$document.on("click", ({target}) => {
    if(window.innerWidth < 1200) {
      if (!$(target).closest(".header-search-form").length) {
        searchForm.removeClass("expanded");
        searchField.val("");
        langSwitcher.removeClass("hidden");
      }
    }
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerSearch.js